const delay = timeout => new Promise((resolve, reject) => setTimeout(_ => resolve(timeout), timeout))

export default delay
